import React, { ReactElement, useEffect, useState } from 'react';
import { SiteDto } from '../../../api/ClientApi';
import { useNavigate, useParams } from 'react-router';
import { WarehouseClient } from '../../../api/Extensions';
import SiteInfo from '../../sites/SiteInfo';
import { Box, Typography, DialogContent, Slide, SlideProps } from '@mui/material';
import AddGoodsToSite from './AddGoodsToSite';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '../../../hooks/hooks';
import { clearGoods } from '../../../redux/actions/goodsActions';

import { FormDialogTitle } from '../../../common/components/form/FormPrimitives';

import { ResponsiveDialog } from '../../../common/components/mobile/MobilePrimitives';

const Transition = React.forwardRef(function Transition(props: SlideProps, ref) {
    return <Slide {...props} direction="right" ref={ref} />;
});

export default function GoodsToSiteForm(): ReactElement {
    const [currSite, setCurrSite] = useState<SiteDto | undefined>(undefined);

    const dispatch = useAppDispatch();

    const params = useParams();
    const location = useLocation();

    const path = location.pathname;

    const navigate = useNavigate();

    useEffect(() => {
        const siteId = params.siteId;
        if (!!siteId && !isNaN(+siteId) && +siteId > 0) {
            WarehouseClient.getSiteById(+siteId, true, true).then((res) => setCurrSite(res));
        }
    }, [params]);

    const handleClose = () => {
        if (path.indexOf('/constructionSites/') !== -1 || path.indexOf('/warehouses/') !== -1) {
            dispatch(clearGoods());
            navigate('..');
        } else if (path.indexOf('/goods/') !== -1) {
            dispatch(clearGoods());
            navigate('../..');
        }
    };

    return (
        <div>
            <ResponsiveDialog fullScreen open onClose={handleClose} TransitionComponent={Transition}>
                <FormDialogTitle onClose={handleClose}>Dodavanje robe - Skladište</FormDialogTitle>
                <DialogContent dividers sx={{ px: { xs: 2, sm: 5 }, pt: { xs: 3, sm: 5 } }}>
                    <Box sx={{ mb: 5 }}>
                        <Typography variant="body1" component="h6" style={{ fontSize: 20 }}>
                            Informacije o skladištu
                        </Typography>
                        <hr />
                        <SiteInfo site={currSite} />
                    </Box>
                    <Box>
                        <AddGoodsToSite
                            siteId={params?.siteId ? +params?.siteId : undefined}
                            close={handleClose}
                            site={currSite}
                        />
                    </Box>
                </DialogContent>
            </ResponsiveDialog>
        </div>
    );
}
